import React, { useState } from 'react';
import { Switch } from '@mui/material';


import { ConfirmDialog, LoadingPage } from 'components';
import { changeStatusWebServiceApi } from '../../services/WebServiceServices';

const ShowSwitch = ({ rowData }) => {

  const { id } = rowData;

  const [selectedVal, setSelectedVal] = useState(rowData.enable);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const confirm = async () => {
    setLoading(true);
    setOpenDialog(false);

    try {
      await changeStatusWebServiceApi({
        enable: selectedVal,
        serviceCallId: id,
      });

      rowData.enable = selectedVal;
      setSelectedVal((val) => !val);

    } catch (error) {

    }
    setLoading(false);
  };

  const changeStatus = (e) => {
    setSelectedVal(e.target.checked);

    if (!e.target.checked) {
      setOpenDialog(true);
      return;
    }

    setLoading(true);

    confirm();
  };

  return (
    <>
      <ConfirmDialog
        open={openDialog}
        onClose={closeDialog}
        onConfirm={confirm}
        title="غیرفعال سازی سرویس"
        content={`آیا از غیرفعال سازی سرویس "<b>${rowData.name}</b>" اطمینان دارید؟`}
        confirmButtonText="تایید"
        cancelButtonText="انصراف"
      />

      {loading ? (
        <LoadingPage />
      ) : (
        <Switch
          color="primary"
          checked={rowData.enable}
          onChange={changeStatus}
          name="active"
          className='iosSwitch'
        />
      )}
    </>
  );
};

export default ShowSwitch;
